
    import {computed, ComputedRef, defineComponent, reactive, watch, createApp} from 'vue'
    import componentTitle from './componentTitle.vue';
    import {useStore} from "@/store";
    import {useRoute} from "vue-router"
    import utils from '@/util/index';
    import { Switch, Toast } from '@souche-ui/vant-next';
    import '@souche-ui/vant-next/es/switch/style';

    interface CheckItemShow {
        Accident: boolean;
        Fire: boolean;
        SoakWater: boolean;
        Appearance: boolean;
        Interior: boolean;
        Lighting: boolean;
        Machine: boolean;
        Power: boolean;
        Bottom: boolean;
        StartUp: boolean;
    }

    interface State {
        entrustList: object[];
        entrustListAll: object[];
        entrustListFlaw: object[];
        needListenScroll: boolean;
        checkItemShow: CheckItemShow;
        onlyFlaw: boolean;
        checkModules: object[];
        hasWarn: boolean;
        queryModules: any;
    }

    export default defineComponent({
        name: "entrust",
        setup() {
            let state: State = reactive({
                entrustList: [], // 渲染的检测项列表
                entrustListAll: [], // 全部检测项列表
                entrustListFlaw: [], // 存在瑕疵的检测项列表
                needListenScroll: false, // 监听滚动
                checkItemShow: {
                    Accident: false,
                    Fire: false,
                    SoakWater: false,
                    Appearance: false,
                    Interior: false,
                    Lighting: false,
                    Machine: false,
                    Power: false,
                    Bottom: false,
                    StartUp: false,
                },
                onlyFlaw: false,
                checkModules: [],
                hasWarn: true,
                queryModules: []

            })
            const {query} = useRoute();
            let store = useStore()
            let tocOnlyShowFlaw: ComputedRef<{}> = computed<{}>(() => store.state.tocOnlyShowFlaw)
            watch(tocOnlyShowFlaw, (data: any) => {
                state.onlyFlaw = data;
            })
            function getElementToPageTop (el) {
                if (el.offsetParent) {
                    return getElementToPageTop(el.offsetParent) + el.offsetTop
                }
                else {
                    return el.offsetTop
                }
            }
            function clickTab(id: string) { // 点击委托检测项
                state.needListenScroll = false;
                const sTop = document.documentElement.scrollTop || document.body.scrollTop;
                const eTopEl: any = document.getElementById(id);
                const topNum = getElementToPageTop(eTopEl);
                state.checkItemShow[id] = true;
                store.dispatch('saveCheckItemShow', {checkItemShow: state.checkItemShow})
                utils.scrollTop(window, sTop, topNum - 55, 500);
                setTimeout(() => {
                    state.needListenScroll = true;
                }, 300);
            }
            // 设置瑕疵检测项
            function setEntrustListToFlaw () {
                let arr = [];
                let checkModules = state.checkModules;
                for (let i=0;i<checkModules.length;i++) {
                    let item = checkModules[i];
                    if ((item as any).defectCount>0) {
                        (arr as any).push(item);
                    }
                }
                state.entrustListFlaw = arr;
            }
            // 设置全量检测项
            function setEntrustListToAll () {
                state.entrustListAll = state.checkModules;
            }
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo, (data: any) => {
                const {checkModules, haveDefect,queryModules} = data;
                let querys: any[] = [];
                if (queryModules && queryModules.length) {
                    querys = [...queryModules];
                }
                let tempModules = [...checkModules];
                for (let index = 0; index < querys.length; index++) {
                    let element: any = querys[index];
                    if (element.code === "KABatteryQuery"||element.code === "BaoxianHistory") {
                        element.haveSearchIcon = true;
                    }
                    tempModules.push(element);
                }
                state.queryModules = queryModules;
                state.checkModules = tempModules;
                state.hasWarn = haveDefect;
                setEntrustListToFlaw();
                setEntrustListToAll();
                state.entrustList = state.entrustListAll;
            })
            let onlyFlaw: ComputedRef<{}> = computed<{}>(() => state.onlyFlaw)
            watch(onlyFlaw, (data: any) => {
                if (data) {
                    state.entrustList = state.entrustListFlaw;
                } else {
                    state.entrustList = state.entrustListAll;
                }
            }) 
            store.dispatch('saveTocOnlyShowFlaw', false);
            function changeShowFlaw(data) {
                store.dispatch('saveTocOnlyShowFlaw', data);
                if (data) {
                    Toast('已筛选当前瑕疵项');
                }
                console.log('saveTocOnlyShowFlaw', data);
            }
            return {
                state,
                clickTab,
                changeShowFlaw
            }
        },
        components: {
            componentTitle,
            Switch,
            // Toast
        },
        methods: {
            // changeShowFlaw(data) {
            //     // let store = useStore();
            //     console.log(this.state.onlyFlaw, data);
            //     useStore().dispatch('saveTocOnlyShowFlaw', data)
                
            // }
        }
        
    })
